exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-pointer[data-v-8d80a9e6]{cursor:pointer}.card-body-minimum[data-v-8d80a9e6]{min-height:100px}", ""]);

// exports
